import CRMauth from "@/services/CRMinitAuth"
import { cm_list } from "@/../tests/unit/__utils__/mock-cm"

// const courseList = query => {
//   return Promise.resolve(cm_list)
// }

const courseList = query =>
  CRMauth.get(`${process.env.VUE_APP_CRM_API}common/courses/`, {
    params: query
  });

const courseListDetailed = query =>
  CRMauth.get(`${process.env.VUE_APP_CRM_API}common/courses/detailed/`, {
    params: query
  });

const courseListOnlyDates = query =>
  CRMauth.get(`${process.env.VUE_APP_CRM_API}common/courses/only_dates/`, {
    params: query
  })

const createCourse = data =>
  CRMauth.post(`${process.env.VUE_APP_CRM_API}common/courses/`, data);

const updateCourse = (courseID, data) =>
  CRMauth.put(`${process.env.VUE_APP_CRM_API}common/courses/${courseID}/`, data);

const removeCourse = (courseID) =>
  CRMauth.delete(`${process.env.VUE_APP_CRM_API}common/courses/${courseID}/`);

const createExam = (courseID, data) =>
  CRMauth.post(`${process.env.VUE_APP_CRM_API}common/courses/${courseID}/course_exams/`, data);

const getConfig = courseID =>
  CRMauth.get(`${process.env.VUE_APP_CRM_API}common/courses/${courseID}/course_exams/`);

const createConfig = (courseID, data) =>
  CRMauth.post(`${process.env.VUE_APP_CRM_API}common/courses/${courseID}/course_exams/`, data);

const updateConfig = payload =>
  CRMauth.put(`${process.env.VUE_APP_CRM_API}common/courses/${payload.courseID}/course_exams/${payload.settingID}/`, payload.data);

const removeConfig = payload =>
  CRMauth.delete(`${process.env.VUE_APP_CRM_API}common/courses/${payload.courseID}/course_exams/${payload.settingID}/`);

const getCourseConfiguration = courseID =>
  CRMauth.get(`${process.env.VUE_APP_CRM_API}common/courses/${courseID}/course_configurations/`);

const createCourseConfiguration = (courseID, data) =>
  CRMauth.post(`${process.env.VUE_APP_CRM_API}common/courses/${courseID}/course_configurations/`, data);

const updateCourseConfiguration = (courseID, configurationID, data) =>
  CRMauth.put(`${process.env.VUE_APP_CRM_API}common/courses/${courseID}/course_configurations/${configurationID}/`, data);

const removeConfiguration = (courseID, configurationID)  =>
  CRMauth.delete(`${process.env.VUE_APP_CRM_API}common/courses/${courseID}/course_configurations/${configurationID}/`);

export default {
  courseList,
  createCourse,
  createExam,
  courseListDetailed,
  getConfig,
  createConfig,
  removeConfig,
  updateCourse,
  removeCourse,
  courseListOnlyDates,
  getCourseConfiguration,
  createCourseConfiguration,
  updateCourseConfiguration,
  removeConfiguration,
  updateConfig
}
